var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('customList',{ref:"customList",attrs:{"filterItems":_vm.formItems,"filterModel":_vm.filter,"columns":_vm.columns,"listUrl":'/admin/loginlog/list'},on:{"selectChange":_vm.selectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }